import React from 'react';
import { FormattedMessage } from 'react-intl';

const FormattedSimpleMessage = (props) => <FormattedMessage {...props}>{(text) => text}</FormattedMessage>;

export default FormattedSimpleMessage;
